import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';
import { useMostRecentExamAttempt, useExamAttemptExpiry } from '../../exams';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamExpiredIncompleteExercisesScreen = ({
  trackId,
  language
}) => {
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId), language);
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    attemptExpiresOn,
    attemptExpiryLoading,
    attemptExpiryError
  } = useExamAttemptExpiry(Number(trackId), language);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      language: language,
      trackId: trackId,
      use: "primary"
    }),
    error: mostRecentExamAttemptError || attemptExpiryError || trackError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.examExpiredPracticalsIncomplete"
    }),
    illustration: "announcement",
    language: language,
    loading: mostRecentExamAttemptLoading || attemptExpiryLoading || trackLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.examExpiredPracticalsIncompleteSubheading",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: attemptExpiresOn
        })
      }
    }),
    trackId: trackId
  });
};
export default ExamExpiredIncompleteExercisesScreen;